import { toISTDate } from '@Apis/constants';
import dayjs from 'dayjs';

const getPricingRuleTextAndColor = (pricingRule) => {
  if (pricingRule === 'MARK_UP_PERCENTAGE') {
    return {
      text: 'Markup',
      color: 'green',
    };
  }
  if (pricingRule === 'MARK_DOWN_PERCENTAGE') {
    return {
      text: 'Markdown',
      color: 'red',
    };
  }
  return { text: '', color: 'black', arrow: null };
};
const getDatesDiff = (fromDate, toDate) => {
  const today = dayjs();
  const diffInDays = dayjs(toDate).diff(dayjs(fromDate), 'day', false);
  if (diffInDays === 0) {
    return 'Today';
  }
  let diff = '';
  if (diffInDays > 360) {
    const years = Math.floor(diffInDays / 365);
    diff = `${years} Year${years > 1 ? 's' : ''}`;
  } else if (diffInDays > 180) {
    const months = Math.floor(diffInDays / 30);
    diff = `${months} Month${months > 1 ? 's' : ''}`;
  } else if (diffInDays > 28) {
    const weeks = Math.floor(diffInDays / 7);
    diff = `${weeks} Week${weeks > 1 ? 's' : ''}`;
  } else if (diffInDays > 0) {
    diff = `${diffInDays} Day${diffInDays > 1 ? 's' : ''}`;
  }
  return diff;
};

const getExpiryStatus = (expiryDate) => {
  const today = dayjs();
  const expiry = dayjs(expiryDate);
  const hoursDifference = expiry.diff(today, 'hour');

  if (hoursDifference > 24) {
    const daysDifference = Math.floor(hoursDifference / 24);
    if (daysDifference > 7) {
      const weeks = Math.floor(daysDifference / 7);
      return `Expires in ${weeks} week${weeks > 1 ? 's' : ''} `;
    }
    return `Expires in ${daysDifference} day${daysDifference > 1 ? 's' : ''}`;
  }

  if (
    hoursDifference === 0
    || hoursDifference > 1
    || hoursDifference > 0
    || hoursDifference === -1
  ) {
    return 'Expires Today';
  }

  if (hoursDifference >= -24) {
    const hoursAgo = Math.abs(hoursDifference);
    return `Expired ${hoursAgo} hour${hoursAgo > 1 ? 's' : ''} ago`;
  }

  const daysAgo = Math.abs(Math.floor(hoursDifference / 24));
  return `Expired ${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
};
const ListScreenKeys = ({ documentData, user }) => {
  const record = documentData;
  const { text, color, arrow } = getPricingRuleTextAndColor(
    record?.pricing_rule,
  );

  return [
    {
      label: 'List #',
      value: `${record?.price_list_doc_number}`,
    },
    {
      label: 'Location',
      value: record?.tenant_info?.find(
        (item) => item.tenant_id === user.tenant_info.tenant_id,
      )?.tenant_name || record?.tenant_info[0]?.tenant_name,
    },
    {
      label: 'Price List Name',
      value: record?.price_list_name,
    },
    {
      label: 'Price List Type',
      value: `${record?.price_list_type
        ? record?.price_list_type.split('_').join(' ').toProperCase()
        : '-'} - ${text} ${record?.pricing_rule_percentage != null
          ? `${Math.abs(record?.pricing_rule_percentage)}%`
          : ''}`,
    },
    {
      label: 'Validity',
      value: record?.valid_from && record?.valid_to ? `${getDatesDiff(
        toISTDate(record?.valid_from),
        toISTDate(record?.valid_to),
      )} ${dayjs
        .utc(record?.valid_from)
        .utcOffset('+05:30')
        .format('DD/MM/YYYY')} - (${dayjs
          .utc(record?.valid_to)
          .utcOffset('+05:30')
          .format('DD/MM/YYYY')})` : '-',
    },
    {
      label: 'Pricing Scheme',
      value: record?.pricing_scheme === 'VOLUME_PRICING'
        ? 'Slab Pricing'
        : record?.pricing_scheme
          ? record?.pricing_scheme.split('_').join(' ').toProperCase()
          : '-',
    },
    {
      label: 'Expiry Status',
      value: record?.valid_to != null ? getExpiryStatus(
        dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
      ) : '-',
    },
  ];
};

export default ListScreenKeys;